// Runtime values are injected by entrypoint.sh into /build/env.js as window.__ENV__.
// Falling back to the build-time process.env values covers local development (npm start / npm run dev).
declare global {
  interface Window {
    __ENV__?: {
      REACT_APP_API_BASEURL?: string;
      REACT_APP_DOCUMENTS_BASEURL?: string;
      APP_MASTER_CONFIGURATION_MANAGER_URL?: string;
      APP_VERSION?: string;
      /** Same image as this container; used for stale-bundle detection (see useAppVersionCheck). */
      BUILD_RUN_ID?: string;
      REACT_APP_AAD_CLIENT_ID?: string;
      REACT_APP_AAD_TENANT_ID?: string;
      REACT_APP_AAD_REDIRECT_URI?: string;
      REACT_APP_AAD_POST_LOGOUT_REDIRECT_URI?: string;
      REACT_APP_AAD_SCOPES?: string;
    };
  }
}

const env = window.__ENV__ || {};

export var environment = {
  production: true,
  baseURL: env.REACT_APP_API_BASEURL || process.env.REACT_APP_API_BASEURL || '',
  documentsBaseURL:
    env.REACT_APP_DOCUMENTS_BASEURL ||
    process.env.REACT_APP_DOCUMENTS_BASEURL ||
    '',
  version: env.APP_VERSION || process.env.APP_VERSION || 'unknown',
  buildRunId: env.BUILD_RUN_ID || '',
  masterConfigurationManagerURL:
    env.APP_MASTER_CONFIGURATION_MANAGER_URL ||
    process.env.APP_MASTER_CONFIGURATION_MANAGER_URL ||
    '',
  aadClientId:
    env.REACT_APP_AAD_CLIENT_ID || process.env.REACT_APP_AAD_CLIENT_ID || '',
  aadTenantId:
    env.REACT_APP_AAD_TENANT_ID || process.env.REACT_APP_AAD_TENANT_ID || '',
  aadRedirectUri:
    env.REACT_APP_AAD_REDIRECT_URI ||
    process.env.REACT_APP_AAD_REDIRECT_URI ||
    '',
  aadPostLogoutRedirectUri:
    env.REACT_APP_AAD_POST_LOGOUT_REDIRECT_URI ||
    process.env.REACT_APP_AAD_POST_LOGOUT_REDIRECT_URI ||
    '',
  aadScopes: env.REACT_APP_AAD_SCOPES || process.env.REACT_APP_AAD_SCOPES || 'User.Read',
};
